// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"382":"versions-sidebar","744":"metadata-sidebar","806":"activity-sidebar","836":"details-sidebar","885":"skills-sidebar"}[chunkId] + "." + {"382":"b9507e01","744":"00050fde","806":"47610dfa","836":"cfa217d8","885":"db96cf0a"}[chunkId] + ".chunk.css";
};